import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Capacitor } from "@capacitor/core";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import GroupBookingPage from "@/pages/GroupBookingPage";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancel from "@/pages/BookingCancel";
import CheckStatus from "@/pages/CheckStatus";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ITAdminDashboard from "@/pages/ITAdminDashboard";
import EmploymentLetter from "@/pages/EmploymentLetter";
import BillOfLadingPage from "@/pages/BillOfLadingPage";
import ShippingPage from "@/pages/ShippingPage";
import DriverApp from "@/pages/DriverApp";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ReschedulePage from "@/pages/ReschedulePage";
import ReviewPage from "@/pages/ReviewPage";
import TrackBookingPage from "@/pages/TrackBookingPage";
import MakePaymentPage from "@/pages/MakePaymentPage";
import BankRunPage from "@/pages/BankRunPage";
import CheckinPage from "@/pages/CheckinPage";
import ChatWidget from "@/components/ChatWidget";
import { InstallPrompt } from "@/components/InstallPrompt";

function App() {
  useEffect(() => {
    // Log platform for debugging
    if (Capacitor.isNativePlatform()) {
      console.log("Running as native app on:", Capacitor.getPlatform());
    }
  }, []);

  return (
    <LanguageProvider>
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/group-booking" element={<GroupBookingPage />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/booking/cancel" element={<BookingCancel />} />
          <Route path="/check-status" element={<CheckStatus />} />
          <Route path="/make-payment" element={<MakePaymentPage />} />
          <Route path="/bank-run" element={<BankRunPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/it-admin" element={<ITAdminDashboard />} />
          <Route path="/employment-letter" element={<EmploymentLetter />} />
          <Route path="/bill-of-lading" element={<BillOfLadingPage />} />
          <Route path="/driver" element={<DriverApp />} />
          <Route path="/reschedule/:bookingId" element={<ReschedulePage />} />
          <Route path="/review/:bookingId" element={<ReviewPage />} />
          <Route path="/track/:bookingId" element={<TrackBookingPage />} />
          <Route path="/checkin" element={<CheckinPage />} />
        </Routes>
        <ChatWidget />
        <InstallPrompt />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
    </LanguageProvider>
  );
}

export default App;
